import { render } from "./UserProfile.vue?vue&type=template&id=1cf5c14a&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"

import "./UserProfile.vue?vue&type=style&index=0&id=1cf5c14a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1cf5c14a"

export default script